<script lang="ts" setup>
import useStore from "@src/stores/store";
import {shorten} from "@src/helpers/utils";
import ChatMessage from "@src/types/ChatMessage";
import {computed} from "vue";
import Sender from "@src/types/Sender";
import ChatSession from "@src/types/ChatSession";
import Media from "@src/components/views/HomeView/MainArea/ChatArea/Message/Media.vue";
import {useChatSessionStore} from "@src/stores/chatSession";
import IconButton from "@src/components/ui/inputs/IconButton.vue";
import {XCircleIcon} from "@heroicons/vue/24/outline";
import Group from "@src/types/Group";
import GroupMessage from "@src/types/GroupMessage";
import GroupMember from "@src/types/GroupMember";


const sessionStore = useChatSessionStore()

const props = defineProps<{
    input: boolean,
    message: ChatMessage | GroupMessage;
    session: ChatSession | Group
    self?: boolean;
}>();
const isGroup = computed<boolean>(() => {
    return sessionStore.type === 'group'
})

const sender = computed<Sender>(() => {
    let fromCostumer: boolean
    let costumer: any
    if (isGroup.value) {
        fromCostumer = (props.message as any).costumer_id !== null
        costumer = (props.session as any).members?.find((member: GroupMember) => member.id === (props.message as any).costumer_id)
    } else {
        fromCostumer = props.message.from === 'costumer'
        costumer = (props.session as any).costumer
    }
    let user = store.user
    return {
        id: fromCostumer ? costumer?.id : user?.id || 0,
        name: fromCostumer ? costumer?.name : user?.firstName || 'Usuário',
        avatar: fromCostumer ? costumer?.profile_picture : user?.avatar || '',
        type: isGroup.value ? (fromCostumer ? 'user' : 'costumer') : (props.message.from ?? '')
    }
})
const store = useStore();

const clearReply = () => {
    sessionStore.replyMessage = undefined;
};

function scrollToMessage() {
    document.getElementById(`message-${props.message.id}`)?.scrollIntoView({ behavior: 'smooth' });
}
</script>

<template>

    <div
        v-if="props.message"
        :aria-label="'reply to: ' + sender.name"
        :class="['border-gray-900/50', 'dark:border-white/50']"
        class="border-l-2 pl-3 cursor-pointer pointer outline-none duration-200"
        tabindex="0"
        @click="scrollToMessage"
    >
        <!--name-->
        <div
            class="mb-3 flex items-center justify-between gap-2"
        >
            <p
                :class="[
            'text-black',
            'opacity-60',
            'dark:text-white',
            'dark:opacity-70',
        ]"
                class="font-semibold text-xs leading-4 tracking-[.01rem]"
            >
                {{
                    store.user && sender.id !== store.user.id
                        ? sender.name
                        : "Você"
                }}
            </p>

            <IconButton
                v-if="props.input && sessionStore.replyMessage && sessionStore.selectedSession?.pinned_message?.id !== props.message.id"
                aria-label="close reply message"
                class="ic-btn-ghost-primary cursor-pointer w-7 h-7 mt-4 mr-4"
                title="close reply message"
                @click="clearReply"
            >
                <XCircleIcon class="w-5 h-5"/>
            </IconButton>
        </div>


        <!--content-->
        <p
            v-if="props.message.type === 'text'"
            class="body-2 text-black opacity-50 dark:text-white dark:opacity-70"
        >
            {{ shorten(isGroup ? props.message.content : ((props.message as any).message || ''), 60) }}
        </p>

        <!--attachments title-->
        <div
            v-else
            class="body-2 text-black opacity-50 dark:text-white dark:opacity-70"
        >
            <Media
                :message="props.message"
                :preview="true"
                :self="props.self"
            />
        </div>
    </div>
</template>
